import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { readAuthToken } from '@noor/api';
import { SignInPage } from '@/pages/sign-in';

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    // Already signed in → skip the login screen and go straight to the launcher.
    // The mirror of `/welcome`'s guard: between them a merchant always lands on
    // the screen their session state warrants, whichever URL they arrive at.
    if (readAuthToken()) {
      // `redirect()` is TanStack Router's control-flow throw, not an Error.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/welcome' });
    }
  },
  component: LoginRoute,
});

/**
 * Public sign-in screen (full-bleed, rendered without the app shell — see
 * `__root.tsx`). It is the landing target for the `@noor/api` 401 redirect, so
 * it must be a real route: an unauthenticated request never dead-ends on an
 * unmatched path. On sign-in the route hands off to the `/welcome` launcher,
 * where the merchant picks which sub-app to enter.
 */
function LoginRoute() {
  const navigate = useNavigate();

  return <SignInPage onSignedIn={() => void navigate({ to: '/welcome' })} />;
}
